import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const ADD_MANUAL_SHARES = gql`
  mutation AddManualShares($projectId: ID!, $input: ManualSharesInput!) {
    addManualShares(projectId: $projectId, manualSharesInput: $input) {
      ...ManualShares
    }
  }
  ${fragments.manualShares}
`

export const SAVE_MANUAL_SHARES = gql`
  mutation SaveManualShares($manualSharesId: ID!, $input: ManualSharesInput!) {
    saveManualShares(manualSharesId: $manualSharesId, manualSharesInput: $input) {
      ...ManualShares
    }
  }
  ${fragments.manualShares}
`

export const DELETE_MANUAL_SHARES = gql`
  mutation DeleteManualShares($manualSharesId: ID!) {
    deleteManualShares(manualSharesId: $manualSharesId)
  }
`

// Remote
export const _ADD_MANUAL_SHARES = gql`
  mutation _AddManualShares($projectId: ID!, $input: ManualSharesInput!) {
    _addManualShares(projectId: $projectId, manualSharesInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MANUAL_SHARES = gql`
  mutation _SaveManualShares($manualSharesId: ID!, $input: ManualSharesInput!) {
    _saveManualShares(manualSharesId: $manualSharesId, manualSharesInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_MANUAL_SHARES = gql`
  mutation _DeleteManualShares($manualSharesId: ID!) {
    _deleteManualShares(manualSharesId: $manualSharesId) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_MANUAL_SHARES = gql`
  mutation _SaveMultipleManualShares(
    $projectId: ID!
    $roundId: ID!
    $manualSharesInputs: [ManualSharesInput!]!
  ) {
    _saveMultipleManualShares(
      projectId: $projectId
      roundId: $roundId
      manualSharesInputs: $manualSharesInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_MANUAL_SHARES,
  saveRemote: _SAVE_MANUAL_SHARES,
  deleteRemote: _DELETE_MANUAL_SHARES,
  saveOp: '_saveManualShares',
  addOp: '_addManualShares',
  deleteOp: '_deleteManualShares',
}

export const manualSharesQueries = mutations
